module.exports = __webpack_public_path__ + "af8d4299389539daee2ad0a2d2b9907b.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/phonecase-mockup.jpg
// module id = 797
// module chunks = 0